import axios from "axios";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const BASE_URL = "/motivational";

async function fetchAllMotivationalQuotes({ token }) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(`${SERVER_URL}${BASE_URL}`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function saveMotivationalQuote({ payload, token }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.put(`${SERVER_URL}${BASE_URL}`, {
      ...payload,
    });

    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchSavedMotivationalQuote({ token, msisdn }) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(`${SERVER_URL}${BASE_URL}/${msisdn}`);

    return data;
  } catch (e) {
    throw e;
  }
}

async function deleteSavedMotivationalQuote({ token, _id }) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.delete(`${SERVER_URL}${BASE_URL}?_id=${_id}`);

    return data;
  } catch (e) {
    throw e;
  }
}

const MotivationalService = {
  fetchAllMotivationalQuotes,
  saveMotivationalQuote,
  fetchSavedMotivationalQuote,
  deleteSavedMotivationalQuote,
};

export default MotivationalService;
